
import React from 'react';
import PropTypes from 'prop-types';

import restrictNumber from '../../../utils/restrictNumber';
import ColorInput from '../../../components/common/ColorInput';
import {
  StyledOptionColorRow,
  StyledOptionFieldCell,
  StyledOptionFieldGrid,
  StyledOptionFieldLabel,
  StyledOptionSliderSlot,
  StyledSpacedOptionFields,
} from './AnnotationOptions.styled';
import Slider from '../Slider';

const SHADOW_SLIDER_WIDTH = '100%';

const ShadowFields = ({ annotation, updateAnnotation, t }) => {
  const {
    shadowOffsetX,
    shadowOffsetY,
    shadowBlur,
    shadowColor,
    shadowOpacity,
  } = annotation;

  const changeSliderValue = (property, newValue, min = 0, max = 100) => {
    updateAnnotation({
      [property]: restrictNumber(newValue, min, max),
    });
  };

  const changeShadowColor = (newShadowColor) => {
    updateAnnotation({ shadowColor: newShadowColor });
  };

  const renderSliderCell = (labelKey, sliderProps) => (
    <StyledOptionFieldCell>
      <StyledOptionFieldLabel>{t(labelKey)}</StyledOptionFieldLabel>
      <StyledOptionSliderSlot>
        <Slider width={SHADOW_SLIDER_WIDTH} {...sliderProps} />
      </StyledOptionSliderSlot>
    </StyledOptionFieldCell>
  );

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel respark_shadow-option-fields">
      <StyledOptionFieldGrid>
        {renderSliderCell('horizontal', {
          annotation: 'px',
          min: -100,
          max: 100,
          onChange: (val) =>
            changeSliderValue('shadowOffsetX', val, -100, 100),
          value: shadowOffsetX || 0,
        })}
        {renderSliderCell('vertical', {
          annotation: 'px',
          min: -100,
          max: 100,
          onChange: (val) =>
            changeSliderValue('shadowOffsetY', val, -100, 100),
          value: shadowOffsetY || 0,
        })}
        {renderSliderCell('blur', {
          annotation: 'px',
          onChange: (val) => changeSliderValue('shadowBlur', val),
          value: shadowBlur,
        })}
        {renderSliderCell('opacity', {
          annotation: '%',
          onChange: (val) =>
            changeSliderValue('shadowOpacity', val / 100, 0, 1),
          value: Math.round(shadowOpacity * 100),
        })}
      </StyledOptionFieldGrid>
      <StyledOptionColorRow>
        <StyledOptionFieldLabel>{t('color')}</StyledOptionFieldLabel>
        <ColorInput color={shadowColor} onChange={changeShadowColor} />
      </StyledOptionColorRow>
    </StyledSpacedOptionFields>
  );
};

ShadowFields.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default ShadowFields;
